import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "No I-94 drive to Chicago — we handle agency submission",
      "Ideal for North Dakota state government travelers",
      "Perfect for Bismarck professionals on international business",
      "Great for BSC and University of Mary students studying abroad",
      "Bismarck Municipal Airport (BIS) flyers",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no Chicago drive required",
      "Faster than self-service at Bismarck post offices",
      "Good for planned international trips from BIS",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Bismarck USPS is primary acceptance facility",
      "No document review — errors cause rejection and restart",
      "In-person clerk appointment required at Burleigh County facilities",
      "North Dakota mail routing adds extra transit days",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "No passport agency in North Dakota — closest is Chicago, ~700 miles via I-94",
      "10+ hour drive to Chicago Regional Passport Agency",
      "NPIC appointment required — no walk-ins at Chicago agency",
      "Life-or-death emergencies only with documentation",
      "Winter blizzards on I-94 can close highways entirely Nov–Mar",
      "Remote location makes same-day Chicago trips impossible",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function ProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Bismarck"
      headingExtra="ND"
      introText="Bismarck travelers have several options — but North Dakota has zero passport agencies in the entire state, which makes emergency processing especially challenging. The nearest agency is Chicago — approximately 700 miles east. Here's how each route compares and why most choose a registered courier to handle their passport."
      options={options}
      emergencyDescription="Strictly for documented life-or-death emergencies only. The closest passport agency is the Chicago Passport Agency at 230 S Dearborn St Suite 380, Chicago IL 60604 — approximately 700 miles, 10 hours via I-94. Winter blizzards can close I-94 entirely from November through March. No walk-ins — NPIC appointment required."
      disclaimerText="*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing. North Dakota has no passport agency — nearest is Chicago, IL (~700 miles)."
    />
  );
}